/* ============================================================
   เปิด / ดาวน์โหลดไฟล์ที่ต้องส่ง token (ไฟล์อยู่ใน uploads/private เปิดตรงไม่ได้)
   request = () => axios.get(..., { responseType: "blob" })
============================================================ */

/* error ของ request แบบ blob อ่านข้อความจาก API ไม่ได้ตรง ๆ ต้องแปลงก่อน */
export const blobError = async (err, fallback = "เปิดไฟล์ไม่สำเร็จ") => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const j = JSON.parse(await data.text());
      return j?.message || fallback;
    } catch (e) {
      return fallback;
    }
  }
  return data?.message || err?.message || fallback;
};

export const canPreview = (mime = "") => mime.startsWith("image/") || mime === "application/pdf";

/** inline = true เปิดแท็บใหม่ (รูป/PDF) , false = ดาวน์โหลด */
export async function openFile(request, file, inline = true) {
  /* เปิดแท็บไว้ก่อน — กันเบราว์เซอร์มือถือบล็อก popup หลัง await */
  const preview = inline && canPreview(file?.mime);
  const win = preview ? window.open("", "_blank") : null;
  try {
    const res = await request();
    const blob = new Blob([res.data], { type: file?.mime || res.data?.type || "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    if (preview && win) {
      win.location.href = url;
    } else {
      const a = document.createElement("a");
      a.href = url;
      a.download = file?.file_name || "file";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    throw new Error(await blobError(e));
  }
}

export const formatSize = (n) => {
  const v = Number(n) || 0;
  if (v < 1024) return `${v} B`;
  if (v < 1024 * 1024) return `${(v / 1024).toFixed(0)} KB`;
  return `${(v / 1024 / 1024).toFixed(1)} MB`;
};

/* ชนิดไฟล์ที่ API รับ (ต้องตรงกับ api/common/file-lib.php) */
export const FILE_ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp,.heic,.dwg,.dxf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip";
export const FILE_MAX_MB = 20;
export const FILE_MAX_COUNT = 10;
